import { CommandBar, ICommandBarItemProps } from 'office-ui-fabric-react/lib/CommandBar';
import { IButtonProps } from '@fluentui/react';
import { useHistory } from 'react-router';
import { useEffect, useState } from 'react';
import MenuService from '../../services/MenuService';

const _overflowItems: ICommandBarItemProps[] = [];
const overflowProps: IButtonProps = { ariaLabel: 'Más acciones' };

const PortfolioMenu = () => {
    const history = useHistory();
    const [isMarketEnabled, setIsMarketEnabled] = useState(false);

    const buildMenuItems = (marketEnabled: boolean): ICommandBarItemProps[] => {
        const baseItems: ICommandBarItemProps[] = [
            {
                text: 'Resumen de cartera',
                key: 'portfolio',
                onClick: () => history.push('/portfolio'),
                className: window.location.pathname === '/portfolio' ? 'is-selected' : ''
            },
            {
                text: 'Ficha',
                key: 'file',
                onClick: () => history.push('/portfolio/file'),
                className: window.location.pathname === '/portfolio/file' ? 'is-selected' : ''
            },
            {
                text: 'Órdenes-New',
                key: 'ordersNew',
                onClick: () => history.push('/portfolio/ordersNew'),
                className: window.location.pathname === '/portfolio/ordersNew' ? 'is-selected' : ''
            },
            {
                text: 'Operaciones realizadas',
                key: 'operations',
                onClick: () => history.push('/portfolio/operations'),
                className: window.location.pathname === '/portfolio/operations' ? 'is-selected' : ''
            },
            {
                text: 'Órdenes en curso',
                key: 'orders',
                onClick: () => history.push('/portfolio/orders'),
                className: window.location.pathname === '/portfolio/orders' ? 'is-selected' : ''
            },
            {
                text: 'Información fiscal',
                key: 'fiscal_report',
                onClick: () => history.push('/portfolio/fiscalReport'),
                className: window.location.pathname === '/portfolio/fiscalReport' ? 'is-selected' : ''
            }
        ];

        if (marketEnabled) {
            baseItems.push({
                text: 'Mercado',
                key: 'market',
                onClick: () => history.push('/portfolio/market'),
                className: window.location.pathname === '/portfolio/market' ? 'is-selected' : ''
            });
        }

        return baseItems;
    };

    const [menuItems, setMenuItems] = useState<ICommandBarItemProps[]>(buildMenuItems(false));

    useEffect(() => {
        MenuService.getMarketItemEnable().then(setIsMarketEnabled);
    }, []);

    useEffect(() => {
        setMenuItems(buildMenuItems(isMarketEnabled));
    }, [window.location.pathname, isMarketEnabled]);

    return (
        <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12" id="main-menu">
                <CommandBar
                    items={menuItems}
                    overflowItems={_overflowItems}
                    overflowButtonProps={overflowProps}
                    ariaLabel="Usa las flechas izquierda y derecha para navegar entre las entradas del menú"
                />
            </div>
        </div>
    );
};


export default PortfolioMenu;
